export const blockTypeNames: Record<string, string> = {
  Tabs: 'Tabs',
  FooterCompanyData: 'Company Data',
  FooterPaymentShippingIcons: 'Payment & Shipment Icons',
  FooterFootnote: 'Footer Footnote',
};
